import {FIELD_TYPES} from 'Core/Constant';

export const ICON_CLASSES = {};

ICON_CLASSES[FIELD_TYPES.Time] = 'glyphicon-time';
ICON_CLASSES[FIELD_TYPES.TimeSpan] = 'glyphicon-time';
ICON_CLASSES[FIELD_TYPES.Date] = 'glyphicon-calendar';
ICON_CLASSES[FIELD_TYPES.DateTime] = 'glyphicon-calendar';